import config from 'config';

export default [
  'ResourceService',
  class MarketplaceService {
    constructor(resourceService) {
      this._resourceService = resourceService;
      this._API_BASE = '/market';
    }

    searchMarketplace(page, type, minPrice, maxPrice, name, term){
      if (_.isUndefined(page)) {
        this._resourceService.errorPromise('marketplace:search: missing parameters');
      }

      let query = `from=${(page - 1) * config.Marketplace.LIMIT}&per_page=${config.Marketplace.LIMIT}`;
      if(name && name !== 'ALL') query += `&category=${encodeURIComponent(name)}`;
      if(term) query += `&term=${encodeURIComponent(term)}`;
      if(type && type !== '0') query += `&type=${type}`;
      if(minPrice > config.Marketplace.MIN_PRICE) query += `&min_price=${minPrice}`;
      if(maxPrice < config.Marketplace.MAX_PRICE) query += `&max_price=${maxPrice}`;
      query += `&v=${moment().format()}`;

      return this._resourceService.get(`${this._API_BASE}/search?${query}`);
    }

    productTypes(){
      return this._resourceService.get(`${this._API_BASE}/list-types`);
    }

    categories() {
      return this._resourceService.get(`${this._API_BASE}/categories`);
    }

    categoriesTree() {
      return this._resourceService.get(`${this._API_BASE}/categories-tree`);
    }

    suggest(term){
      if (!term) {
        this._resourceService.errorPromise('marketplace:suggest: missing parameter');
      }
      return this._resourceService.get(`${this._API_BASE}/suggest?term=${encodeURIComponent(term)}`);
    }

    initializeGlobalDiscount(csdc, csdcEmail) {
        let data = {
            csdc: csdc,
            csdc_email: csdcEmail
        };

        return this._resourceService.post(`/global-discount`, data);
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/api-services/marketplace-service.js